import React from 'react';

import { useIntl } from 'react-intl';

import { IconButton } from '@atlaskit/button/new';
import ArrowUpIcon from '@atlaskit/icon/core/arrow-up';
import VideoStopOverlayIcon from '@atlaskit/icon/core/video-stop-overlay';
import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';

import messages from './messages';
import type { ControlPanelProps } from './types';

export const ControlPanel = ({
	isAgentTyping,
	isSendDisabled,
	promptDraftAndModeKey,
	submitButtonTooltip,
	tooltipOptions,
	onSave,
	onAbort,
	getChatMode,
}: ControlPanelProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const showSubmitInsteadOfStop = isAgentTyping && !isSendDisabled && fg('rovo_chat_message_queue');

	return isAgentTyping && !showSubmitInsteadOfStop ? (
		<IconButton
			isTooltipDisabled={false}
			onClick={(_, e) => {
				onAbort(getChatMode(promptDraftAndModeKey), e);
			}}
			icon={(iconProps) => (
				<VideoStopOverlayIcon {...iconProps} color={token('color.icon.danger')} label={''} />
			)}
			label={formatMessage(messages.stopGeneratingButtonLabel)}
		/>
	) : (
		<IconButton
			isTooltipDisabled={false}
			tooltip={submitButtonTooltip ? tooltipOptions : undefined}
			appearance="primary"
			onClick={onSave}
			type="submit"
			isDisabled={isSendDisabled}
			interactionName="ai-mate.send-message-button"
			icon={(iconProps) => <ArrowUpIcon {...iconProps} label={''} />}
			label={submitButtonTooltip ? submitButtonTooltip : formatMessage(messages.sendButtonLabel)}
		/>
	);
};
